import DataConst from 'consts/DataConst';
import BaseController from './BaseController';

class ProductController extends BaseController {
  model = DataConst.MODELS.PRODUCT;
}

export default new ProductController();
